import { MINUTES_IN_DAY } from '@repo/constants';
const isValidDate = (date)=>date instanceof Date && !isNaN(date.getTime());
const initialDateOptions = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
};
const formatDate = function(date) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!date) {
        return '---';
    }
    const DateTimeFormat = new Intl.DateTimeFormat('en-US', Object.assign(initialDateOptions, options));
    return DateTimeFormat.format(new Date(date));
};
const formatDateTime = (date)=>{
    if (!date) {
        return '';
    }
    return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
    });
};
const formatTime = (date)=>{
    if (!date) {
        return '';
    }
    return new Date(date).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
    });
};
const formatDateEnUs = (date)=>{
    if (!date) {
        return '';
    }
    return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
const getMinutesInCurrentMonth = ()=>{
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const daysInMonth = new Date(year, month, 0).getDate();
    return daysInMonth * MINUTES_IN_DAY;
};
const getGMTInfo = ()=>{
    const date = new Date();
    const offsetInMinutes = date.getTimezoneOffset();
    const offsetInHours = Math.abs(offsetInMinutes / 60);
    const sign = offsetInMinutes > 0 ? '-' : '+';
    return "".concat(sign).concat(Math.floor(offsetInHours).toString());
};
const formatDateWithIntl = (dateString, timeZone)=>{
    var _ref, _ref1, _ref2, _ref3;
    var _parts_find, _parts_find1, _parts_find2, _parts_find3, _parts_find4, _parts_find5, _parts_find6;
    if (!dateString) {
        return {
            year: '',
            month: '',
            day: '',
            time: ''
        };
    }
    const date = new Date(dateString);
    if (!isValidDate(date)) {
        return {
            year: '',
            month: '',
            day: '',
            time: ''
        };
    }
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone === 'UTC' ? 'UTC' : undefined,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });
    const parts = formatter.formatToParts(date);
    const year = (_ref = (_parts_find = parts.find((part)=>part.type === 'year')) === null || _parts_find === void 0 ? void 0 : _parts_find.value) !== null && _ref !== void 0 ? _ref : '';
    const month = (_ref1 = (_parts_find1 = parts.find((part)=>part.type === 'month')) === null || _parts_find1 === void 0 ? void 0 : _parts_find1.value) !== null && _ref1 !== void 0 ? _ref1 : '';
    const day = (_ref2 = (_parts_find2 = parts.find((part)=>part.type === 'day')) === null || _parts_find2 === void 0 ? void 0 : _parts_find2.value) !== null && _ref2 !== void 0 ? _ref2 : '';
    const hour = (_parts_find3 = parts.find((part)=>part.type === 'hour')) === null || _parts_find3 === void 0 ? void 0 : _parts_find3.value;
    const minute = (_parts_find4 = parts.find((part)=>part.type === 'minute')) === null || _parts_find4 === void 0 ? void 0 : _parts_find4.value;
    const second = (_parts_find5 = parts.find((part)=>part.type === 'second')) === null || _parts_find5 === void 0 ? void 0 : _parts_find5.value;
    const dayPeriod = (_parts_find6 = parts.find((part)=>part.type === 'dayPeriod')) === null || _parts_find6 === void 0 ? void 0 : _parts_find6.value;
    const time = "".concat(hour !== null && hour !== void 0 ? hour : '', ":").concat(minute !== null && minute !== void 0 ? minute : '', ":").concat(second !== null && second !== void 0 ? second : '', " ").concat((_ref3 = dayPeriod === null || dayPeriod === void 0 ? void 0 : dayPeriod.toUpperCase()) !== null && _ref3 !== void 0 ? _ref3 : '');
    return {
        year,
        month,
        day,
        time
    };
};
const dateMap = (date)=>{
    const now = new Date();
    const inputDate = new Date(date);
    const isSameDay = now.getFullYear() === inputDate.getFullYear() && now.getMonth() === inputDate.getMonth() && now.getDate() === inputDate.getDate();
    if (isSameDay) {
        return 'Today';
    }
    const msPerDay = 1000 * 60 * 60 * 24;
    const diffInDays = Math.floor((now.getTime() - inputDate.getTime()) / msPerDay);
    if (diffInDays <= 1) {
        return 'Yesterday';
    }
    const diffInMonths = now.getFullYear() * 12 + now.getMonth() - (inputDate.getFullYear() * 12 + inputDate.getMonth());
    if (diffInDays < 30) {
        return "".concat(diffInDays.toString(), " day").concat(diffInDays > 1 ? 's' : '', " ago");
    }
    if (diffInMonths >= 1 && diffInMonths <= 3) {
        return "".concat(diffInMonths.toString(), " month").concat(diffInMonths > 1 ? 's' : '', " ago");
    }
    return formatDateEnUs(inputDate.toDateString());
};
export const checkDataBeforeToday = (currentDate)=>{
    const today = new Date();
    return today.getTime() > currentDate.getTime();
};
export function formatDateTimeLocal(date) {
    if (!date) {
        return '';
    }
    return "".concat(String(date.getFullYear()), "-").concat(String(date.getMonth() + 1).padStart(2, '0'), "-").concat(String(date.getDate()).padStart(2, '0'), "T").concat(String(date.getHours()).padStart(2, '0'), ":").concat(String(date.getMinutes()).padStart(2, '0'), ":").concat(String(date.getSeconds()).padStart(2, '0'));
}
const formatDateShortNumeric = (date)=>new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
function getDaysLabel(days) {
    if (days <= 0) {
        return 'Token is expired';
    }
    if (days > 90) {
        return 'Permanent';
    }
    return "".concat(days.toString(), " days");
}
function treatAsUTC(date) {
    const result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
}
export function daysBetween(param) {
    let { startDate, endDate } = param;
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    return Math.round((treatAsUTC(endDate).valueOf() - treatAsUTC(startDate).valueOf()) / millisecondsPerDay);
}
export function expiredDate(date) {
    const days = daysBetween({
        startDate: new Date(),
        endDate: date
    });
    return days <= 0 || days > 90 ? getDaysLabel(days) : formatDateShortNumeric(date.toISOString());
}
export function expiredDays(date) {
    const days = daysBetween({
        startDate: new Date(),
        endDate: date
    });
    return getDaysLabel(days);
}
function mapQueryDateRange(dateRange) {
    if (!dateRange) {
        return undefined;
    }
    const [start, end] = dateRange.split('/').map((date)=>new Date(date));
    if (!start || !end) {
        return undefined;
    }
    return {
        start,
        end
    };
}
function mapQueryDateToPicker(dateRange) {
    if (!dateRange) {
        return null;
    }
    const res = dateRange.split('/').map((date)=>new Date(date));
    const [first, second] = res;
    if (!first || !second) {
        return null;
    }
    return [
        first,
        second
    ];
}
export const dateStringGMT = (date)=>{
    if (!date) {
        return '';
    }
    const formatDate = formatDateWithIntl(date, undefined);
    if (!formatDate.month) {
        return '';
    }
    return "".concat(formatDate.month, " ").concat(formatDate.day, ", ").concat(formatDate.year);
};
export { dateMap, formatDate, formatDateTime, formatDateWithIntl, formatTime, getGMTInfo, getMinutesInCurrentMonth, isValidDate, mapQueryDateRange, mapQueryDateToPicker };
